
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34463',
  depVersions: {
  "documents-public-ui": "static-1.34463",
  "client-types": "static-1.466",
  "documents-lib": "static-1.34468",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2121",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4994",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5581",
  "hs-test-utils": "static-1.8000",
  "hub-http": "static-1.6210",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11455",
  "I18n": "static-7.1621",
  "jasmine-immutable": "static-1.3008",
  "jasmine-runner": "static-1.6453",
  "lodash": "static-1.3",
  "quartz": "static-1.7014",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16654",
  "reporting-data": "static-1.67468",
  "reporting-testing-lib": "static-1.9401",
  "reporting-visualizations": "static-1.59544",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4752",
  "webpack-env": "static-1.54",
  "atom": "static-1.5057",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2485",
  "classnames": "static-2.10",
  "cssUtils": "static-1.787",
  "customer-data-filters-ui": "static-1.39693",
  "customer-data-objects": "static-1.7652",
  "customer-data-property-utils": "static-1.8075",
  "data-fetching-client": "static-1.9657",
  "enviro": "static-4.446",
  "FireAlarmUi": "static-1.4502",
  "flux-actions": "static-1.336",
  "FormsCommonComponents": "static-1.85790",
  "FormUrlGenerator": "static-2.4704",
  "foundations-components": "static-1.7903",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4115",
  "HubStyle": "static-2.11762",
  "icons": "static-2.645",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7145",
  "metrics-js": "static-1.9619",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.397",
  "property-description-translator": "static-1.3831",
  "property-translator": "static-1.5386",
  "quartz-config": "static-1.792",
  "quartz-core": "static-1.6233",
  "quick-fetch": "static-1.3905",
  "raven": "static-3.5907",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5333",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8156",
  "reference-resolvers-lite": "static-1.8080",
  "report-customization-components": "static-1.13110",
  "reporting-enablement": "static-1.22855",
  "reporting-reports": "static-1.67146",
  "reporting-snowflake": "static-1.56086",
  "reporting-ui-components": "static-2.64739",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4637",
  "sales-content-partitioning": "static-1.8929",
  "SalesContentIndexUI": "static-3.9218",
  "sanitize": "static-1.4463",
  "sanitize-text": "static-1.8128",
  "self-service-api": "static-1.10235",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1736",
  "signup-constants": "static-1.18811",
  "signup-ui-lego-core": "static-1.20821",
  "signup-ui-url-generator": "static-2.8032",
  "styled-components": "static-2.89",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4750",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10980",
  "ui-addon-i18n": "static-1.11138",
  "ui-addon-react-router-dom": "static-1.9531",
  "ui-addon-upgrades": "static-9.17963",
  "ui-asset-management-lib": "static-1.11003",
  "ui-images": "static-2.1149",
  "UIComponents": "static-3.8401",
  "usage-tracker": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-container": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-core": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-public": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "viral-links-lib": "static-1.7046",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven-hubspot": "static-1.6214",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3389",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3291",
  "quartz-webpack": "static-1.3238",
  "ai-components-ui-library": "static-1.8898",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4852",
  "foundations-theming": "static-1.4405",
  "quartz-auth": "static-1.689",
  "ui-business-units-lib": "static-1.9036",
  "usage-tracker-session-replay": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "foundations-theming-base": "static-1.3390",
  "HeadJS": "static-2.757",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3111",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.70",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4314",
  "csstype": "static-1.50",
  "quartz-head": "static-1.679",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7916",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3575",
  "persist-promise": "static-1.3684",
  "quartz-i18n": "static-1.689",
  "reporting-client-types": "static-1.2497",
  "foundations-components-legacy": "static-1.928",
  "hs-story-utils": "static-1.9413",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9921",
  "hubspotter-http": "static-1.4641",
  "sassPrefix": "static-1.155",
  "events-data-lib": "static-1.203",
  "conversations-skeleton-state": "static-1.7233",
  "crm-message-bus": "static-1.42932",
  "customer-data-filters-ui-msw-helpers": "static-1.22128",
  "customer-data-objects-ui-components": "static-1.13011",
  "customer-data-reference-ui-components": "static-1.13147",
  "customer-data-ui-utilities": "static-1.9812",
  "framework-builder-read-service-client": "static-1.3994",
  "framework-data-schema-quick-fetch": "static-1.6775",
  "framework-data-schema-resolvers": "static-1.6870",
  "inbound-db-properties-service-client": "static-1.3835",
  "multi-account-reference-resolvers": "static-1.965",
  "onboarding-tours": "static-1.16565",
  "reporting-datasets-permissions-lib": "static-1.13628",
  "ui-addon-teams": "static-1.21523",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68306",
  "customer-data-properties": "static-1.51478",
  "forms-ai-lib": "static-1.4296",
  "forms-utils-lib": "static-1.12545",
  "foundations-components-test-utils": "static-1.5386",
  "react-dnd-compat": "static-1.4604",
  "react-tinymce": "static-1.55190",
  "tinymce-config": "static-2.54316",
  "ui-gdpr-components": "static-1.10335",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4172",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.19",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1863",
  "ui-fonts": "static-1.717",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "mobile-manifest-mixins": "static-1.532",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.444",
  "quartz-test": "static-1.689",
  "quartz-tracking": "static-1.393",
  "batch-promise": "static-1.1527",
  "external-options-client-types": "static-1.4147",
  "react-colorpicker": "static-2.10196",
  "ui-addon-draggable-compat": "static-2.4242",
  "copilot-toolkit": "static-1.11091",
  "data-quality-ui-library": "static-1.12970",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6448",
  "reporting-action-components": "static-1.41254",
  "reporting-filters": "static-1.292",
  "reporting-insights-lib": "static-1.1684",
  "reporting-plugins": "static-1.10298",
  "ui-addon-opt": "static-4.8357",
  "zustand": "static-1.74",
  "growth-payments-core": "static-1.25319",
  "hubspot-apollo-client": "static-1.4864",
  "bend-plugin-chirp-manifest": "static-1.47",
  "chirp-fetch": "static-1.1872",
  "sales-templates-service-types-lib": "static-1.4159",
  "merchandise-lib": "static-1.263",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5855",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4069",
  "nested-table": "static-1.213",
  "timezone-utils": "static-2.5230",
  "bender-build-tools": "static-1.3186",
  "chatspot-core": "static-1.21208",
  "bend-plugin-foundations-theming": "static-1.2888",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9919",
  "hs-resources": "static-1.142",
  "pulse": "static-1.560",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3786",
  "crm-pipelines-api-client-types": "static-1.4127",
  "multi-currency-client-types": "static-1.3680",
  "getting-started-shared-tasks": "static-1.18451",
  "growth-data-modal": "static-1.5405",
  "growth-onboarding-confetti": "static-1.3053",
  "growth-onboarding-next-action-utils": "static-1.1867",
  "navigation-components": "static-1.17979",
  "onboarding-tours-client": "static-1.4779",
  "onboarding-tours-utils": "static-1.631",
  "ui-shepherd-react": "static-3.10145",
  "ui-shepherd-tracker": "static-1.7526",
  "ui-universal-auth": "static-1.8961",
  "user-context": "static-1.5090",
  "cms-field-types": "static-1.4797",
  "content-icons-ui": "static-1.2221",
  "integrations-lib": "static-1.16061",
  "calling-global-api": "static-1.64451",
  "calling-internal-common": "static-1.31287",
  "calling-lifecycle-internal": "static-1.65833",
  "calling-lifecycle-messages": "static-1.58127",
  "commerce-products-lib": "static-1.9494",
  "crm-links": "static-1.6273",
  "customer-data-properties-shared-msw-handlers": "static-1.9248",
  "file-manager-components": "static-1.23571",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4212",
  "meetings-icalendar-utils-lib": "static-1.617",
  "object-builder-ui-client": "static-1.48675",
  "pipeline-validation-client-types": "static-1.3954",
  "property-value-citations": "static-1.2092",
  "smart-property-lib": "static-1.6862",
  "tiered-pricing": "static-1.1169",
  "ui-addon-iframeable": "static-1.9042",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19799",
  "tinymce-themes": "static-1.56286",
  "data-token-picker": "static-1.16378",
  "hub-http-contrib": "static-1.3029",
  "interframe": "static-3.4746",
  "tinymce-data": "static-1.40401",
  "tinymce-plugins": "static-1.57430",
  "ui-addon-sales-email": "static-1.5198",
  "magpie-lib": "static-1.5543",
  "magpie-types": "static-1.5003",
  "simple-logging-lib": "static-1.3035",
  "content-assistance-lib": "static-1.7728",
  "dashboard-lib": "static-1.81457",
  "ExportDialog": "static-6.10378",
  "hubspot-prosemirror": "static-1.18194",
  "hubspot-prosemirror-plugins": "static-1.18186",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8691",
  "campaign-roi-lib": "static-1.9040",
  "feedback-loader": "static-1.29264",
  "apollo-link-hub-http": "static-2.4636",
  "hubspot-apollo-cache": "static-1.323",
  "purchase-motions-api": "static-1.5858",
  "trials-service-types": "static-1.3890",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.159",
  "markdown-it": "static-1.6",
  "bend-plugin-pulse": "static-1.63",
  "directed-graph": "static-1.921",
  "event-emitter": "static-1.934",
  "fast-json-patch": "static-1.62",
  "onboarding-data-sync-lib": "static-1.1933",
  "growth-onboarding-next-action-components": "static-1.1895",
  "user-context-client": "static-1.4598",
  "idb-keyval": "static-1.43",
  "nest": "static-1.212",
  "reactive-lib": "static-1.709",
  "unified-auth-core-lib": "static-1.757",
  "getting-started-shared-tasks-store": "static-1.17569",
  "integrations-error-boundary-lib": "static-1.13476",
  "integrations-tracking-lib": "static-1.5586",
  "native-integrations-shared-strings": "static-1.7769",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10355",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.475",
  "calling-error-reporting": "static-1.31294",
  "shared-worker-versioning": "static-1.11024",
  "calling-usage-tracker": "static-1.6527",
  "voice-sms-access-library": "static-1.912",
  "customer-data-tracking": "static-1.6874",
  "commerce-permissions": "static-1.755",
  "products-iframe-lib": "static-1.7882",
  "products-ui-components-shared-msw-handlers": "static-1.10303",
  "location-customization-utils-lib": "static-1.9195",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4141",
  "video-components-external": "static-1.11207",
  "video-data-lib": "static-1.34865",
  "data-agent-kit": "static-1.171",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10004",
  "fsm": "static-1.3718",
  "policy-lib": "static-1.6767",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10067",
  "navigation-messaging": "static-1.7306",
  "FileManagerLib": "static-1.39211",
  "NamespacedHubStyle": "static-2.9048",
  "FileManagerCore": "static-1.39070",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12414",
  "layout-dnd-utils": "static-1.11389",
  "react-codemirror": "static-1.10612",
  "ui-addon-emoji-picker": "static-1.9875",
  "ui-brand-identity-lib": "static-1.15210",
  "ui-addon-video-player": "static-1.8689",
  "ui-coaching-tips": "static-1.28498",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23482",
  "EmailSignatureEditor": "static-1.24329",
  "breeze-engine-lib": "static-1.566",
  "InboxConnectUtils": "static-4.14763",
  "universal-page-editor-lib": "static-1.3000",
  "google-sheets-integration-lib": "static-1.180",
  "microsoft-drive-integration-lib": "static-1.298",
  "calling-orchestration-schema": "static-1.35689",
  "sales-views-client-types": "static-1.4251",
  "crm-record-cards-service-types": "static-1.3587",
  "content-media-composition-data-lib": "static-1.12196",
  "content-media-compositions": "static-2.16203",
  "media-bridge-lib": "static-1.18896",
  "trellis-story-utils": "static-1.4503",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5892",
  "FileManagerImages": "static-1.36722",
  "video-components": "static-1.13210",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4523",
  "video-embed": "static-1.35699",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68381",
  "layout-data-lib": "static-1.9714",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6568",
  "commerce-tours-lib": "static-1.6063",
  "growth-onboarding-reliability": "static-1.5068",
  "sales-checkout-service-client": "static-1.3627",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21644",
  "sales-email-signature-service-client": "static-1.3829",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22034",
  "outpost": "static-1.4171",
  "advanced-menus-core": "static-1.15105",
  "advanced-menus-lib": "static-1.12048",
  "ui-memberships-settings-lib": "static-1.33995",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15104",
  "simple-menus-lib": "static-1.16621"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34463",
  "client-types": "/client-types/static-1.466",
  "documents-lib": "/documents-lib/static-1.34468",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2121",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4994",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5581",
  "hs-test-utils": "/hs-test-utils/static-1.8000",
  "hub-http": "/hub-http/static-1.6210",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11455",
  "I18n": "/I18n/static-7.1621",
  "jasmine-immutable": "/jasmine-immutable/static-1.3008",
  "jasmine-runner": "/jasmine-runner/static-1.6453",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.7014",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16654",
  "reporting-data": "/reporting-data/static-1.67468",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9401",
  "reporting-visualizations": "/reporting-visualizations/static-1.59544",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4752",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5057",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2485",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.787",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39693",
  "customer-data-objects": "/customer-data-objects/static-1.7652",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8075",
  "data-fetching-client": "/data-fetching-client/static-1.9657",
  "enviro": "/enviro/static-4.446",
  "FireAlarmUi": "/FireAlarmUi/static-1.4502",
  "flux-actions": "/flux-actions/static-1.336",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85790",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4704",
  "foundations-components": "/foundations-components/static-1.7903",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyle": "/HubStyle/static-2.11762",
  "icons": "/icons/static-2.645",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7145",
  "metrics-js": "/metrics-js/static-1.9619",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "property-description-translator": "/property-description-translator/static-1.3831",
  "property-translator": "/property-translator/static-1.5386",
  "quartz-config": "/quartz-config/static-1.792",
  "quartz-core": "/quartz-core/static-1.6233",
  "quick-fetch": "/quick-fetch/static-1.3905",
  "raven": "/raven/static-3.5907",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5333",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8156",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8080",
  "report-customization-components": "/report-customization-components/static-1.13110",
  "reporting-enablement": "/reporting-enablement/static-1.22855",
  "reporting-reports": "/reporting-reports/static-1.67146",
  "reporting-snowflake": "/reporting-snowflake/static-1.56086",
  "reporting-ui-components": "/reporting-ui-components/static-2.64739",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4637",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8929",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9218",
  "sanitize": "/sanitize/static-1.4463",
  "sanitize-text": "/sanitize-text/static-1.8128",
  "self-service-api": "/self-service-api/static-1.10235",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1736",
  "signup-constants": "/signup-constants/static-1.18811",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20821",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8032",
  "styled-components": "/styled-components/static-2.89",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4750",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10980",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11138",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9531",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17963",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11003",
  "ui-images": "/ui-images/static-2.1149",
  "UIComponents": "/UIComponents/static-3.8401",
  "usage-tracker": "/usage-tracker/static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-container": "/usage-tracker-container/static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-core": "/usage-tracker-core/static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-public": "/usage-tracker-public/static-1-cwunder-network-layer-chunking-backpressure.8",
  "viral-links-lib": "/viral-links-lib/static-1.7046",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3389",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3291",
  "quartz-webpack": "/quartz-webpack/static-1.3238",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8898",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4852",
  "foundations-theming": "/foundations-theming/static-1.4405",
  "quartz-auth": "/quartz-auth/static-1.689",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9036",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-cwunder-network-layer-chunking-backpressure.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3390",
  "HeadJS": "/HeadJS/static-2.757",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3111",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.70",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4314",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.679",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7916",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3575",
  "persist-promise": "/persist-promise/static-1.3684",
  "quartz-i18n": "/quartz-i18n/static-1.689",
  "reporting-client-types": "/reporting-client-types/static-1.2497",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.928",
  "hs-story-utils": "/hs-story-utils/static-1.9413",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9921",
  "hubspotter-http": "/hubspotter-http/static-1.4641",
  "sassPrefix": "/sassPrefix/static-1.155",
  "events-data-lib": "/events-data-lib/static-1.203",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7233",
  "crm-message-bus": "/crm-message-bus/static-1.42932",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22128",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13011",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13147",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9812",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3994",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6775",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6870",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3835",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.965",
  "onboarding-tours": "/onboarding-tours/static-1.16565",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13628",
  "ui-addon-teams": "/ui-addon-teams/static-1.21523",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68306",
  "customer-data-properties": "/customer-data-properties/static-1.51478",
  "forms-ai-lib": "/forms-ai-lib/static-1.4296",
  "forms-utils-lib": "/forms-utils-lib/static-1.12545",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5386",
  "react-dnd-compat": "/react-dnd-compat/static-1.4604",
  "react-tinymce": "/react-tinymce/static-1.55190",
  "tinymce-config": "/tinymce-config/static-2.54316",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10335",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4172",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.19",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1863",
  "ui-fonts": "/ui-fonts/static-1.717",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.532",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.444",
  "quartz-test": "/quartz-test/static-1.689",
  "quartz-tracking": "/quartz-tracking/static-1.393",
  "batch-promise": "/batch-promise/static-1.1527",
  "external-options-client-types": "/external-options-client-types/static-1.4147",
  "react-colorpicker": "/react-colorpicker/static-2.10196",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4242",
  "copilot-toolkit": "/copilot-toolkit/static-1.11091",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12970",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6448",
  "reporting-action-components": "/reporting-action-components/static-1.41254",
  "reporting-filters": "/reporting-filters/static-1.292",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1684",
  "reporting-plugins": "/reporting-plugins/static-1.10298",
  "ui-addon-opt": "/ui-addon-opt/static-4.8357",
  "zustand": "/zustand/static-1.74",
  "growth-payments-core": "/growth-payments-core/static-1.25319",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4864",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.47",
  "chirp-fetch": "/chirp-fetch/static-1.1872",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4159",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5855",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4069",
  "nested-table": "/nested-table/static-1.213",
  "timezone-utils": "/timezone-utils/static-2.5230",
  "bender-build-tools": "/bender-build-tools/static-1.3186",
  "chatspot-core": "/chatspot-core/static-1.21208",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2888",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9919",
  "hs-resources": "/hs-resources/static-1.142",
  "pulse": "/pulse/static-1.560",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3786",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4127",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3680",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18451",
  "growth-data-modal": "/growth-data-modal/static-1.5405",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3053",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1867",
  "navigation-components": "/navigation-components/static-1.17979",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4779",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.631",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10145",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7526",
  "ui-universal-auth": "/ui-universal-auth/static-1.8961",
  "user-context": "/user-context/static-1.5090",
  "cms-field-types": "/cms-field-types/static-1.4797",
  "content-icons-ui": "/content-icons-ui/static-1.2221",
  "integrations-lib": "/integrations-lib/static-1.16061",
  "calling-global-api": "/calling-global-api/static-1.64451",
  "calling-internal-common": "/calling-internal-common/static-1.31287",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65833",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58127",
  "commerce-products-lib": "/commerce-products-lib/static-1.9494",
  "crm-links": "/crm-links/static-1.6273",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9248",
  "file-manager-components": "/file-manager-components/static-1.23571",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4212",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.617",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48675",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3954",
  "property-value-citations": "/property-value-citations/static-1.2092",
  "smart-property-lib": "/smart-property-lib/static-1.6862",
  "tiered-pricing": "/tiered-pricing/static-1.1169",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9042",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19799",
  "tinymce-themes": "/tinymce-themes/static-1.56286",
  "data-token-picker": "/data-token-picker/static-1.16378",
  "hub-http-contrib": "/hub-http-contrib/static-1.3029",
  "interframe": "/interframe/static-3.4746",
  "tinymce-data": "/tinymce-data/static-1.40401",
  "tinymce-plugins": "/tinymce-plugins/static-1.57430",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5198",
  "magpie-lib": "/magpie-lib/static-1.5543",
  "magpie-types": "/magpie-types/static-1.5003",
  "simple-logging-lib": "/simple-logging-lib/static-1.3035",
  "content-assistance-lib": "/content-assistance-lib/static-1.7728",
  "dashboard-lib": "/dashboard-lib/static-1.81457",
  "ExportDialog": "/ExportDialog/static-6.10378",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18194",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18186",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8691",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9040",
  "feedback-loader": "/feedback-loader/static-1.29264",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4636",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.323",
  "purchase-motions-api": "/purchase-motions-api/static-1.5858",
  "trials-service-types": "/trials-service-types/static-1.3890",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.159",
  "markdown-it": "/markdown-it/static-1.6",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.63",
  "directed-graph": "/directed-graph/static-1.921",
  "event-emitter": "/event-emitter/static-1.934",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1933",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1895",
  "user-context-client": "/user-context-client/static-1.4598",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.212",
  "reactive-lib": "/reactive-lib/static-1.709",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.757",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17569",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13476",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5586",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7769",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10355",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.475",
  "calling-error-reporting": "/calling-error-reporting/static-1.31294",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11024",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6527",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.912",
  "customer-data-tracking": "/customer-data-tracking/static-1.6874",
  "commerce-permissions": "/commerce-permissions/static-1.755",
  "products-iframe-lib": "/products-iframe-lib/static-1.7882",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10303",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9195",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4141",
  "video-components-external": "/video-components-external/static-1.11207",
  "video-data-lib": "/video-data-lib/static-1.34865",
  "data-agent-kit": "/data-agent-kit/static-1.171",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10004",
  "fsm": "/fsm/static-1.3718",
  "policy-lib": "/policy-lib/static-1.6767",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10067",
  "navigation-messaging": "/navigation-messaging/static-1.7306",
  "FileManagerLib": "/FileManagerLib/static-1.39211",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9048",
  "FileManagerCore": "/FileManagerCore/static-1.39070",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12414",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11389",
  "react-codemirror": "/react-codemirror/static-1.10612",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9875",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15210",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8689",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28498",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23482",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24329",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.566",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14763",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3000",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.180",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.298",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35689",
  "sales-views-client-types": "/sales-views-client-types/static-1.4251",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12196",
  "content-media-compositions": "/content-media-compositions/static-2.16203",
  "media-bridge-lib": "/media-bridge-lib/static-1.18896",
  "trellis-story-utils": "/trellis-story-utils/static-1.4503",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5892",
  "FileManagerImages": "/FileManagerImages/static-1.36722",
  "video-components": "/video-components/static-1.13210",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4523",
  "video-embed": "/video-embed/static-1.35699",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68381",
  "layout-data-lib": "/layout-data-lib/static-1.9714",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6568",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6063",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5068",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3627",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21644",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3829",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22034",
  "outpost": "/outpost/static-1.4171",
  "advanced-menus-core": "/advanced-menus-core/static-1.15105",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12048",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33995",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15104",
  "simple-menus-lib": "/simple-menus-lib/static-1.16621"
}
};
